import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { AlertErrorDialogComponent } from './alert-error-dialog/alert-error-dialog.component';
import { LoadingComponent } from './loading/loading.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { SoporteComponent } from './soporte/components/soporte.component';
import { AuditoriaComponent } from './auditoria/auditoria.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSharedModule } from '@fuse/shared.module';
import { ConfirmAprobacionInformesSecopComponent } from './confirm-aprobacion-informes-secop/confirm-aprobacion-informes-secop.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SeleccionMesDialogComponent } from './seleccion-mes-dialog/seleccion-mes-dialog.component';
import { MatRadioModule } from '@angular/material/radio';


@NgModule({
  declarations: [
    AlertDialogComponent,
	AlertErrorDialogComponent,
	LoadingComponent,
	ConfirmComponent,
	SoporteComponent,
	AuditoriaComponent,
	ConfirmAprobacionInformesSecopComponent,
	SeleccionMesDialogComponent,
  ],
  entryComponents:[
    AlertDialogComponent,
	AlertErrorDialogComponent,
	LoadingComponent,
	ConfirmComponent,
	SoporteComponent,
	AuditoriaComponent,
	SeleccionMesDialogComponent,
  ],
  imports: [
	CommonModule,
	MatButtonModule,
	MatToolbarModule,
	MatIconModule,
	MatProgressSpinnerModule,
	MatButtonToggleModule,
	MatInputModule,
	MatFormFieldModule,
	MatExpansionModule,
	FuseSharedModule,
	MatCheckboxModule,
	MatRadioModule
  ]
})
export class ByaSharedModule { }
